module.exports = __webpack_public_path__ + "static/media/201-Monolog_ID_2.60fdc00e.mp3";